import { Outlet } from "react-router";
import {
  LayoutDashboard,
  Building2,
  Database,
  Users,
  Brain,
  Cpu,
  Shield,
  Blocks,
} from "lucide-react";
import { SidebarProvider, SidebarInset } from "@kubdee/ui/shadcn/sidebar";
import { AppSidebar, type NavGroup } from "@kubdee/ui/shell/app-sidebar";

const adminNav: NavGroup[] = [
  {
    label: "ภาพรวม",
    items: [
      { title: "แดชบอร์ด", href: "/admin", icon: LayoutDashboard, exact: true },
    ],
  },
  {
    label: "จัดการระบบ",
    items: [
      { title: "Tenants", href: "/admin/tenants", icon: Building2 },
      { title: "D1", href: "/admin/d1", icon: Database },
      { title: "ผู้ใช้ทั้งหมด", href: "/admin/users", icon: Users },
      { title: "โมดูล", href: "/admin/modules", icon: Blocks },
    ],
  },
  {
    label: "AI",
    items: [
      { title: "Providers & API Keys", href: "/admin/ai-providers", icon: Brain },
      { title: "Models", href: "/admin/ai-providers/models", icon: Cpu },
    ],
  },
];

export default function AdminLayout({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <SidebarProvider>
      <AppSidebar title="Super Admin" icon={Shield} color="#DC2626" navGroups={adminNav} />
      <SidebarInset className="flex flex-col h-svh">
        {children ?? <Outlet />}
      </SidebarInset>
    </SidebarProvider>
  );
}
